<div class="te-ust-bar">
  <div class="te-ust-sol">
    <button nz-button nzType="text" nz-tooltip nzTooltipTitle="Geri" (click)="geriDon()">
      <span nz-icon nzType="arrow-left"></span>
    </button>
    <span class="te-baslik">Sablon Editoru</span>
    @if (sablon()?.id) {
      <span class="te-id">{{ sablon()?.id }}</span>
    }
  </div>
  <div class="te-ust-orta">
    <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Palet"
      [class.aktif]="paletAcik()" (click)="paletToggle()">
      <span nz-icon nzType="appstore"></span>
    </button>
    <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Kod Paneli"
      [class.aktif]="kodPaneliAcik()" (click)="kodPaneliToggle()">
      <span nz-icon nzType="code"></span>
    </button>
    <button nz-button nzType="text" nzSize="small" nz-tooltip nzTooltipTitle="Ozellikler"
      [class.aktif]="stilPaneliAcik()" (click)="stilPaneliToggle()">
      <span nz-icon nzType="sliders"></span>
    </button>
    <span class="te-ayirici"></span>
    <button nz-button nzType="text" nzSize="small" nz-tooltip
      [nzTooltipTitle]="tamEkran() ? 'Kucult' : 'Tam Ekran'" (click)="tamEkranToggle()">
      <span nz-icon [nzType]="tamEkran() ? 'fullscreen-exit' : 'fullscreen'"></span>
    </button>
  </div>
  <div class="te-ust-sag">
    @if (sablon()?.tur) {
      <nz-tag [nzColor]="sablon()?.tur === 'widget' ? 'blue' : 'green'">{{ sablon()?.tur }}</nz-tag>
    }
    <button nz-button nzType="primary" nzSize="small" (click)="kaydet()">
      <span nz-icon nzType="save"></span> Kaydet
    </button>
  </div>
</div>

<div class="te-govde">
  @if (paletAcik()) {
    <div class="te-palet-wrapper" [class.acik]="paletAcik()">
      <te-palet
        [darMod]="!tamEkran()"
        (elementEklendi)="elementEkle($event)">
      </te-palet>
    </div>
  }

  <div class="te-orta">
    <te-canvas class="te-canvas-alan"
      [sablon]="sablon()"
      [seciliElementId]="seciliElementId()"
      [parametreDegerleri]="parametreler()"
      (elementSecildi)="onElementSecildi($event)"
      (elementGuncellendi)="onElementGuncellendi($event)"
      (elementSilindi)="onElementSilindi($event)"
      (sablonGuncellendi)="sablonGuncelle($event)">
    </te-canvas>

    @if (kodPaneliAcik()) {
      <div class="te-divider" (mousedown)="dividerBasla($event)"><span class="te-divider-gripper"></span></div>
      <te-kod-paneli class="te-kod-alan"
        [style.height.px]="kodPaneliYukseklik()"
        [sablon]="sablon()"
        (htmlDegisti)="onHtmlDegisti($event)"
        (cssDegisti)="onCssDegisti($event)"
        (jsDegisti)="onJsDegisti($event)"
        (olaylarDegisti)="onOlaylarDegisti($event)"
        (kucultTiklandi)="kodPaneliAcik.set(false)">
      </te-kod-paneli>
    }
  </div>

  @if (stilPaneliAcik()) {
    <div class="te-ozellikler">
      <nz-tabs nzSize="small">
        <nz-tab nzTitle="Stil">
          <te-stil-paneli
            [seciliElement]="seciliElement()"
            [sablon]="sablon()"
            (elementGuncellendi)="onElementStilGuncellendi($event)"
            (sablonStilGuncellendi)="onSablonStilGuncellendi($event)"
            (sablonArkaPlanGuncellendi)="onSablonArkaPlanGuncellendi($event)">
          </te-stil-paneli>
        </nz-tab>
        <nz-tab nzTitle="Veri">
          <te-veri-paneli
            [sablon]="sablon()"
            (veriKaynagiDegisti)="onVeriKaynagiDegisti($event)"
            (itemlerDegisti)="onItemlerDegisti($event)">
          </te-veri-paneli>
        </nz-tab>
        <nz-tab nzTitle="Tablo">
          <div class="te-tablo-alan">
            <te-parametre-tablosu
              [sablon]="sablon()"
              [veriler]="parametreTabloVerisi()"
              (veriGuncellendi)="onParametreTabloVeriGuncellendi($event)">
            </te-parametre-tablosu>
          </div>
        </nz-tab>
        <nz-tab nzTitle="Genel">
          <div class="te-genel-panel">
            <div class="te-alan-grup">
              <label>Baslik</label>
              <input nz-input nzSize="small" [ngModel]="sablon()?.baslik" (ngModelChange)="sablonGuncelle({baslik: $event})" />
            </div>
            <div class="te-alan-grup">
              <label>Simge</label>
              <input nz-input nzSize="small" [ngModel]="sablon()?.simge" (ngModelChange)="sablonGuncelle({simge: $event})" />
            </div>
            <div class="te-alan-grup">
              <label>Aciklama</label>
              <textarea nz-input nzSize="small" [ngModel]="sablon()?.aciklama" (ngModelChange)="sablonGuncelle({aciklama: $event})" rows="2"></textarea>
            </div>
          </div>
        </nz-tab>
      </nz-tabs>
    </div>
  }
</div>

<div class="te-mobil-bar">
  <button (click)="mobilPaletAcik.set(true)"><span nz-icon nzType="appstore"></span><span>Palet</span></button>
  <button (click)="mobilStilAcik.set(true)"><span nz-icon nzType="bg-colors"></span><span>Stil</span></button>
  <button (click)="mobilKodAcik.set(true)"><span nz-icon nzType="code"></span><span>Kod</span></button>
  <button (click)="mobilVeriAcik.set(true)"><span nz-icon nzType="database"></span><span>Veri</span></button>
</div>

<nz-modal [nzVisible]="mobilPaletAcik()" (nzOnCancel)="mobilPaletAcik.set(false)" nzTitle="Palet" [nzFooter]="null" nzWidth="100%">
  <ng-container *nzModalContent>
    <te-palet [darMod]="false" (elementEklendi)="elementEkle($event); mobilPaletAcik.set(false)"></te-palet>
  </ng-container>
</nz-modal>

<nz-modal [nzVisible]="mobilStilAcik()" (nzOnCancel)="mobilStilAcik.set(false)" nzTitle="Stil" [nzFooter]="null" nzWidth="100%">
  <ng-container *nzModalContent>
    <te-stil-paneli [seciliElement]="seciliElement()" [sablon]="sablon()"
      (elementGuncellendi)="onElementStilGuncellendi($event)"
      (sablonStilGuncellendi)="onSablonStilGuncellendi($event)"
      (sablonArkaPlanGuncellendi)="onSablonArkaPlanGuncellendi($event)">
    </te-stil-paneli>
  </ng-container>
</nz-modal>

<nz-modal [nzVisible]="mobilKodAcik()" (nzOnCancel)="mobilKodAcik.set(false)" nzTitle="Kod" [nzFooter]="null" nzWidth="100%">
  <ng-container *nzModalContent>
    <te-kod-paneli [sablon]="sablon()"
      (htmlDegisti)="onHtmlDegisti($event)" (cssDegisti)="onCssDegisti($event)"
      (jsDegisti)="onJsDegisti($event)" (olaylarDegisti)="onOlaylarDegisti($event)">
    </te-kod-paneli>
  </ng-container>
</nz-modal>

<nz-modal [nzVisible]="mobilVeriAcik()" (nzOnCancel)="mobilVeriAcik.set(false)" nzTitle="Veri" [nzFooter]="null" nzWidth="100%">
  <ng-container *nzModalContent>
    <te-veri-paneli [sablon]="sablon()"
      (veriKaynagiDegisti)="onVeriKaynagiDegisti($event)"
      (itemlerDegisti)="onItemlerDegisti($event)">
    </te-veri-paneli>
  </ng-container>
</nz-modal>
